import { render, staticRenderFns } from "./ContactListStats.vue?vue&type=template&id=e6135d54"
import script from "./ContactListStats.vue?vue&type=script&lang=js"
export * from "./ContactListStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports